<ng-container *ngIf="showLawyerInfo">
  <h4>{{ lawyerInfoHeading }}</h4>
  <jsg-lawyer-info-view
    [lawFirmName]="lawFirmName"
    [firstName]="lawyerFirstName"
    [lastName]="lawyerLastName"
    [email]="lawyerEmail"
  >
  </jsg-lawyer-info-view>
</ng-container>
<h4 class="mt-20">{{ actionInfoHeading }}</h4>
<jsg-action-parties-view
  [styleOfCause]="styleOfCause"
  [natureOfLitigation]="natureOfLitigation"
  [partySummary]="partySummary"
  [displayedColumns]="displayedColumns"
>
</jsg-action-parties-view>
<div *ngIf="nonSocParties?.length > 0">
  <h4 class="mt-20">Court appointed officer(s)</h4>
  <ccm-ui-action-non-soc-parties-view
    [partySummary]="nonSocParties"
    [displayedColumns]="nonSocPartyDisplayedColumns"
  >
  </ccm-ui-action-non-soc-parties-view>
</div>
